import { apiRequestActions } from '@ackee/redux-utils';
import { fetchElevatorsTypes } from './types';

export default apiRequestActions(fetchElevatorsTypes);
